import { Controller } from "@hotwired/stimulus"
import "./workouts.css"

// Drives the live "elapsed since start" timer in the active-session header.
export default class extends Controller {
  static targets = ["elapsed"]
  static values = { startTime: String }

  connect() {
    if (!this.hasStartTimeValue || !this.hasElapsedTarget) return
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const start = new Date(this.startTimeValue).getTime()
    let s = Math.max(0, Math.floor((Date.now() - start) / 1000))
    const h = Math.floor(s / 3600)
    s -= h * 3600
    const m = Math.floor(s / 60)
    s -= m * 60
    const pad = (n) => String(n).padStart(2, "0")
    this.elapsedTarget.textContent = h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`
  }
}
